import type { CSSProperties } from "react";

// Pagination
export const PAGE_SIZE = 32;

// Wizard/table shared styles
export const STEP_INDICATOR_WRAP: CSSProperties = { marginBottom: 16, textAlign: "center" };
export const DOTS: CSSProperties = { display: "flex", justifyContent: "center", gap: 6 };
export const DOT = (active: boolean): CSSProperties => ({
  width: 10,
  height: 10,
  borderRadius: 9999,
  background: active ? "#0b5cff" : "#d0d7e2",
});

export const NAV_BAR: CSSProperties = {
  display: "flex",
  gap: 8,
  marginTop: 16,
  justifyContent: "space-between",
};

export const BTN: CSSProperties = {
  padding: "12px 16px",
  borderRadius: 8,
  border: "1px solid #ddd",
  background: "#f8f8f8",
  cursor: "pointer",
};

export const BTN_PRIMARY: CSSProperties = {
  ...BTN,
  background: "#0b5cff",
  color: "#fff",
  borderColor: "#0b5cff",
};

export const TABLE_STYLE: CSSProperties = {
  width: "100%",
  borderCollapse: "collapse",
  marginTop: 10,
  tableLayout: "fixed",
};

// Mobile list styles
export const MOBILE_CARD: CSSProperties = {
  border: "1px solid #e5e7eb",
  borderRadius: 10,
  padding: 12,
  marginBottom: 10,
  background: "#fff",
  boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
};
export const MOBILE_ROW: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "110px 1fr",
  alignItems: "baseline",
  columnGap: 10,
  rowGap: 6,
};
export const MOBILE_LABEL: CSSProperties = {
  fontWeight: 600,
  fontSize: 12,
  color: "#6b7280",
};
export const MOBILE_TOPBAR: CSSProperties = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 8,
};
export const MOBILE_FILTERS_WRAP: CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: 8,
  marginBottom: 12,
};

// Edit panel shared styles
export const SERIAL_LINK_BTN: CSSProperties = {
  background: "none",
  border: "none",
  padding: 0,
  margin: 0,
  textDecoration: "underline",
  cursor: "pointer",
};

export const EDIT_PANEL_STYLE: CSSProperties = {
  background: "#fff",
  padding: 16,
  borderRadius: 8,
  width: "min(960px, 95vw)",
  maxHeight: "90vh",
  overflowY: "auto",
  overflowX: "hidden",
  boxSizing: "border-box",
  minWidth: 0,
};
export const EDIT_BACKDROP_STYLE: CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};
export const EDIT_GRID: CSSProperties = { display: "grid", gap: 10 };
export const EDIT_INPUT: CSSProperties = {
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  padding: 8,
};

export const BADGE: CSSProperties = {
  display: "inline-block",
  fontSize: 12,
  background: "#e5e7eb",
  color: "#111827",
  padding: "2px 8px",
  borderRadius: 999,
};
